<template>
    <div id="payout_bank_transfer_component"
         class="payout-option-outer">
        <p>Bank transfer</p>
        <p style="margin-bottom: 15px">Security check:</p>
        <b-row class="payout-option-inner">
            <futuro-network-password :sending="sending"
                                     :show-errors="showErrors"
                                     :set-value="setValue"></futuro-network-password>
        </b-row>
        <p style="margin-bottom: 15px">Enter your bank account data:</p>
        <b-row class="payout-option-inner">
            <iban :sending="sending"
                  :show-errors="showErrors"
                  :set-value="setValue"></iban>
        </b-row>
        <b-row class="payout-option-inner">
            <bic-swift :sending="sending"
                       :show-errors="showErrors"
                       :set-value="setValue"></bic-swift>
        </b-row>
        <b-row class="payout-option-inner">
            <street :sending="sending"
                    :show-errors="showErrors"
                    :set-value="setValue"></street>
        </b-row>
        <b-row class="payout-option-inner">
            <zip :sending="sending"
                 :show-errors="showErrors"
                 :set-value="setValue"></zip>
            <city :sending="sending"
                  :show-errors="showErrors"
                  :set-value="setValue"></city>
        </b-row>
        <b-row class="payout-option-inner">
            <account-currency :sending="sending"
                              :show-errors="showErrors"
                              :set-value="setValue"></account-currency>
            <account-owner :sending="sending"
                           :show-errors="showErrors"
                           :set-value="setValue"></account-owner>
        </b-row>
    </div>
</template>

<script>
    import FuturoNetworkPassword from './common/FuturoNetworkPassword.vue';
    import Iban from './bankTransfer/Iban.vue'
    import BicSwift from './bankTransfer/BicSwift.vue'
    import Street from './common/Street.vue'
    import Zip from './common/Zip.vue'
    import City from './common/City.vue'
    import AccountOwner from './bankTransfer/AccountOwner.vue'
    import AccountCurrency from './bankTransfer/AccountCurrency.vue'

    export default {
        inject: ['$validator'],
        props: ['sending', 'showErrors', 'setValue'],
        components: { FuturoNetworkPassword, Iban, BicSwift, Street, Zip, City, AccountOwner, AccountCurrency }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/payout/BankTransfer.vue